import { render } from "./Searchfile.vue?vue&type=template&id=c1c26208"
import script from "./Searchfile.vue?vue&type=script&lang=js"
export * from "./Searchfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__